import {
  ASSIGN_ALERTS_TO_USER,
  ASSIGN_ALERTS_TO_USER_SUCCESS,
  ASSIGN_ALERTS_TO_USER_FAIL,
  ALERT_ACTION_INFO_MODAL_CLOSE,
  ASSIGN_ALERTS_TO_USER_RESET,
  BULK_UPDATE_ALERT_STATUS,
  BULK_UPDATE_ALERT_STATUS_SUCCESS,
  BULK_UPDATE_ALERT_STATUS_FAIL,
  BULK_UPDATE_ALERT_STATUS_RESET,
  BULK_UPDATE_CASE_STATUS,
  BULK_UPDATE_CASE_STATUS_SUCCESS,
  BULK_UPDATE_CASE_STATUS_FAIL,
  BULK_UPDATE_CASE_STATUS_RESET,
  APPLY_ALERT_STATUS_BULK_IN_CASE,
  APPLY_ALERT_STATUS_BULK_IN_CASE_SUCCESS,
  APPLY_ALERT_STATUS_BULK_IN_CASE_FAIL,
  APPLY_ALERT_STATUS_BULK_IN_CASE_RESET
} from '../../actions/cm/alertAction';

export const initialState = {
  isLoading: false,
  hasError: false,
  showInfoModal: false,
  // FIN-12893 — last Bulk Assign response ({ assigned, notFound }) for the partial-result message.
  assignResult: null,
  errorMessage: '',
  bulkUpdate: {
    isLoading: false,
    hasError: false,
    errorMessage: '',
    result: null
  },
  bulkUpdateCase: {
    isLoading: false,
    hasError: false,
    errorMessage: '',
    result: null
  },
  bulkUpdateInCase: {
    isLoading: false,
    hasError: false,
    errorMessage: '',
    result: null
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case ASSIGN_ALERTS_TO_USER:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: '',
        // FIN-12893 — a new attempt starts with no stale partition.
        assignResult: null
      };
    case ASSIGN_ALERTS_TO_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        showInfoModal: true,
        assignResult: (payload && payload.result) || null
      };
    case ASSIGN_ALERTS_TO_USER_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true,
        errorMessage: payload.message
      };
    case ALERT_ACTION_INFO_MODAL_CLOSE:
      return {
        ...state,
        showInfoModal: false,
        isLoading: false,
        assignResult: null
      };
    case ASSIGN_ALERTS_TO_USER_RESET:
      // FIN-12893 — deliberately KEEP assignResult. AssignAlertModal dispatches this reset from
      // its visibility effect, which fires the instant handleExit() closes the picker on
      // success — i.e. BEFORE the info modal renders. Clearing the partition here made a
      // partial assign display as plain success (caught by the FIN-12893 e2e; jest rendered
      // the modal with the prop pre-set and missed it). Only ALERT_ACTION_INFO_MODAL_CLOSE or
      // a new ASSIGN_ALERTS_TO_USER clears it.
      return {
        ...state,
        isLoading: false,
        hasError: false,
        errorMessage: ''
      };
    case BULK_UPDATE_ALERT_STATUS:
      return {
        ...state,
        bulkUpdate: {
          isLoading: true,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    case BULK_UPDATE_ALERT_STATUS_SUCCESS:
      return {
        ...state,
        bulkUpdate: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: payload
        }
      };
    case BULK_UPDATE_ALERT_STATUS_FAIL:
      return {
        ...state,
        bulkUpdate: {
          isLoading: false,
          hasError: true,
          errorMessage: payload.message,
          result: null
        }
      };
    case BULK_UPDATE_ALERT_STATUS_RESET:
      return {
        ...state,
        bulkUpdate: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    case BULK_UPDATE_CASE_STATUS:
      return {
        ...state,
        bulkUpdateCase: {
          isLoading: true,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    case BULK_UPDATE_CASE_STATUS_SUCCESS:
      return {
        ...state,
        bulkUpdateCase: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: payload
        }
      };
    case BULK_UPDATE_CASE_STATUS_FAIL:
      return {
        ...state,
        bulkUpdateCase: {
          isLoading: false,
          hasError: true,
          errorMessage: payload.message,
          result: null
        }
      };
    case BULK_UPDATE_CASE_STATUS_RESET:
      return {
        ...state,
        bulkUpdateCase: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    // FIN-10098: Apply alert status to other alerts in case
    case APPLY_ALERT_STATUS_BULK_IN_CASE:
      return {
        ...state,
        bulkUpdateInCase: {
          isLoading: true,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    case APPLY_ALERT_STATUS_BULK_IN_CASE_SUCCESS:
      return {
        ...state,
        bulkUpdateInCase: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: payload
        }
      };
    case APPLY_ALERT_STATUS_BULK_IN_CASE_FAIL:
      return {
        ...state,
        bulkUpdateInCase: {
          isLoading: false,
          hasError: true,
          errorMessage: payload.message,
          result: null
        }
      };
    case APPLY_ALERT_STATUS_BULK_IN_CASE_RESET:
      return {
        ...state,
        bulkUpdateInCase: {
          isLoading: false,
          hasError: false,
          errorMessage: '',
          result: null
        }
      };
    default:
      return state;
  }
}
